class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.overlay = document.querySelector("#CartNotification-Overlay");
    this.overlay.addEventListener("click", this.close.bind(this));
    this.notification = document.getElementById("cart-notification");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("open");
    this.overlay.classList.add("open");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.classList.add("hidden");
    document.body.addEventListener("click", this.onBodyClick);
    setTimeout(()=>{
      document.querySelector('#cart-notification .pop_cart_drawer_container').remove()
    },200)
  }

  close() {
    this.notification.classList.remove("open");
    this.overlay.classList.remove("open");
    document.body.classList.remove("hidden");
    document.dispatchEvent(new CustomEvent("body:visible"));
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  // Helper function to open cart drawer
  async openCartDrawer() {
    return new Promise((resolve) => {
      // Try different methods themes use to open cart
      const cartLink = document.getElementById("cart-link");
      if (cartLink) {
        cartLink.click();
        setTimeout(resolve, 300); // Small delay to ensure drawer is open
        return;
      }

      if (typeof window.toggleCart === "function") {
        window.toggleCart();
        setTimeout(resolve, 300);
        return;
      }

      if (typeof window.openCartDrawer === "function") {
        window.openCartDrawer();
        setTimeout(resolve, 300);
        return;
      }

      // Fallback to custom event
      document.dispatchEvent(new CustomEvent("cart:open"));
      setTimeout(resolve, 300);
    });
  }

  // Helper function to update drawer with new HTML
  updateCartDrawerWithHTML(html) {
    // Try common cart drawer selectors
    const selectors = [
      "#CartDrawer",
      ".cart-drawer",
      ".drawer--cart",
      ".mini-cart",
      ".ajaxcart",
      "[data-cart-drawer]",
    ];

    // Create temporary container
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Find the cart drawer in current page
    let currentDrawer = null;
    for (const selector of selectors) {
      currentDrawer = document.querySelector(selector);
      if (currentDrawer) break;
    }

    // Find the new content in response
    let newContent = null;
    for (const selector of selectors) {
      newContent = tempDiv.querySelector(selector);
      if (newContent) break;
    }

    // Update the drawer if found
    if (currentDrawer && newContent) {
      currentDrawer.innerHTML = newContent.innerHTML;

      // Reinitialize any JS components in the drawer
      if (typeof window.initCartDrawer === "function") {
        window.initCartDrawer();
      }
    }
  }

  // Helper function to refresh cart contents
  async refreshCartDrawerContents() {
    try {
      // First try the modern Shopify sections approach
      const sectionResponse = await fetch("/?section_id=cart-drawer");
      if (sectionResponse.ok) {
        const sectionHTML = await sectionResponse.text();
        this.updateCartDrawerWithHTML(sectionHTML);
        return;
      }

      // Fallback to traditional cart drawer endpoint
      const cartResponse = await fetch("/cart?view=drawer");
      const cartHTML = await cartResponse.text();
      this.updateCartDrawerWithHTML(cartHTML);
    } catch (error) {
      console.log("Cart refresh error:", error);
    }
  }

  async renderContents(parsedState) {
    await this.refreshCartDrawerContents();
    await this.openCartDrawer();

    // this.cartItemKey = parsedState.key;
    // this.getSectionsToRender().forEach((section) => {
    //   if (section.id == "cart-drawer") {
    //     if (document.querySelector(section.selector)) {
    //       const elementCartDrawer = document.querySelector(section.selector);
    //       elementCartDrawer.innerHTML = this.getSectionInnerHTML(
    //         parsedState.sections[section.id],
    //         section.selector
    //       );
    //     }
    //     const notificationHTML = "cart-drawer";
    //     const elementNotification = `[id="cart-notification-product-${this.cartItemKey}"]`;
    //     document.getElementById("cart-notification-wrapper").innerHTML =
    //       this.getSectionInnerHTML(
    //         parsedState.sections[notificationHTML],
    //         elementNotification
    //       );
    //   } else {
    //     if (document.querySelector(section.selector)) {
    //       const elements = document.querySelectorAll(section.selector);
    //       Array.from(elements).forEach((element) => {
    //         element.innerHTML = this.getSectionInnerHTML(
    //           parsedState.sections[section.id],
    //           section.selector
    //         );
    //       });
    //     }
    //   }
    // });
    // this.overlay.addEventListener("click", this.close.bind(this));
    // this.open();
  }

  getSectionsToRender() {
    let arraySections = [];
    if (
      window.innerWidth > 920 &&
      document.querySelector(".header-without-sidebars")
    ) {
      arraySections = [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "menu-drawer",
          selector: "#cart-icon-bubble-menu-drawer",
        },
        {
          id: "header",
          selector: "#cart-icon-bubble-header",
        },
        {
          id: "secondary-sidebar",
          selector: "#cart-icon-bubble-secondary-sidebar",
        },
        {
          id: "main-sidebar",
          selector: "#cart-icon-bubble-main-sidebar",
        },
      ];
    } else if (
      window.innerWidth > 920 &&
      document.querySelector(".secondary-header-section")
    ) {
      arraySections = [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "menu-drawer",
          selector: "#cart-icon-bubble-menu-drawer",
        },
        {
          id: "secondary-header",
          selector: "#cart-icon-bubble-secondary-header",
        },
        {
          id: "secondary-sidebar",
          selector: "#cart-icon-bubble-secondary-sidebar",
        },
        {
          id: "main-sidebar",
          selector: "#cart-icon-bubble-main-sidebar",
        },
      ];
    } else {
      arraySections = [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "menu-drawer",
          selector: "#cart-icon-bubble-menu-drawer",
        },
        {
          id: "mobile-header",
          selector: "#cart-icon-bubble-mobile-header",
        },
      ];
    }
    return arraySections;
  }

  async getSectionInnerHTML(html, selector = ".shopify-section") {
    // return new DOMParser()
    //   .parseFromString(html, "text/html")
    //   .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
